export const modalModes = {

    handleOperation: 'handle operation',
    operationInfo: 'operation information',
    categories: 'categories mode',
}